import http from '@/services/http';
import { groupingsFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const groupingsApi = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(filterStatus, groupingsFilters);
    return http.request({
      method: 'get',
      url: '/samples-groupings',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, groupingsFilters);
    return http.request({
      method: 'get',
      url: '/samples-groupings/count',
      params: { where },
      ...config,
    });
  },
  // grouping(id) {
  //   return http.request({
  //     method: 'get',
  //     url: `/samples-groupings/${id}`,
  //   });
  // },
};

export default groupingsApi;
